import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api_middleware";

// Fetch all agent configs
export const fetchAllAgentConfigs = createAsyncThunk(
  "agentConfigs/fetchAllAgentConfigs",
  async () => {
    const response = await api(`v1/admin/agent-configs/`, "GET");
    return response;
  }
);

// Fetch a single agent config by ID
export const fetchAgentConfig = createAsyncThunk(
  "agentConfigs/fetchAgentConfig",
  async (agentConfigId: string) => {
    const response = await api(`v1/admin/agent-configs/${agentConfigId}`, "GET");
    return response;
  }
);

// Create a new agent config
export interface CreateAgentConfigParams {
  organization_id?: string;
  bot_name: string;
  bot_description: string;
  display_name?: string | null;
  override_personality_guidance?: string;
  avatar_config?: {
    avatar_look?: string;
    avatar_voice?: string;
    avatar_voice_personality?: string;
    avatar_default_emotion?: string;
    avatar_language?: string;
    environment?: string;
    avatar_location?: string;
    avatar_pose?: string;
    shot?: string;
  };
  namespace_asset_registry?: {
    namespace_assets: Record<string, string[]>;
  } | null;
}

export const createAgentConfig = createAsyncThunk(
  "agentConfigs/createAgentConfig",
  async (params: CreateAgentConfigParams) => {
    const response = await api(`v1/admin/agent-configs/`, "POST", params);
    return response;
  }
);

// Update an agent config
export interface UpdateAgentConfigParams {
  id: string;
  organization_id?: string;
  bot_name?: string;
  bot_description?: string;
  display_name?: string | null;
  override_personality_guidance?: string;
  avatar_config?: {
    avatar_look?: string;
    avatar_voice?: string;
    avatar_voice_personality?: string;
    avatar_default_emotion?: string;
    avatar_language?: string;
    environment?: string;
    avatar_location?: string;
    avatar_pose?: string;
    shot?: string;
  };
  namespace_asset_registry?: {
    namespace_assets: Record<string, string[]>;
  } | null;
}

export const updateAgentConfig = createAsyncThunk(
  "agentConfigs/updateAgentConfig",
  async (params: UpdateAgentConfigParams) => {
    const { id, ...updateData } = params;
    const response = await api(`v1/admin/agent-configs/${id}`, "PUT", updateData);
    return response;
  }
);
